export default "__VITE_ASSET__92a7f472__"